import { useState } from 'react';
import i18n from 'i18n/config';

import List from 'modules/documents/components/List';
import documentSections from 'constants/documentSections';
import SignaturesHeader from 'modules/documents/components/Header/SignaturesHeader';

const currentSection = 'SIGNATURES';

const Signatures = ({
  documents,
  isLoadingData,
  searchTerm,
  setSignatureDocumentCategory,
  signatureDocumentCategory,
}) => {
  const [section] = useState(
    documentSections(i18n).find((s) => s.tag === currentSection)
  );

  return (
    <>
      <div className="nk-fmg-body-content">
        <SignaturesHeader
          setSignatureDocumentCategory={setSignatureDocumentCategory}
        />
      </div>
      <List
        signatureDocumentCategory={signatureDocumentCategory}
        section={section}
        documents={documents}
        isLoadingData={isLoadingData}
        searchTerm={searchTerm}
      />
    </>
  );
};

export default Signatures;
